import {  ArrowUpRight } from 'lucide-react';
import { useDispatch, useSelector } from 'react-redux';
import { setShowBackToDashboardButton } from '../../store/reducers';
import { useLanguage, getReviewUserDetailsTranslation } from '../../hooks/useLanguage';

export const ReviewUserDetails = ({ userData, navigate }) => {
  const dispatch = useDispatch();
  const company = useSelector(state => state.company);
  const [isSpanish] = useLanguage();

    return (
      <div className="text-left mt-8 text-sm" id='review-user'>
        <div className="circle bg-default mb-2">
          <span className="text-white">2</span>
        </div>
        <div className='flex justify-between gap-4 mb-4 items-center'>
          <h1 className='text-3xl font-bold'>{getReviewUserDetailsTranslation('reviewDetails', isSpanish)}</h1>
        </div>
        <div className='flex justify-between gap-4 mb-2 items-center'>
          <h1 className='text-xl font-bold'>{getReviewUserDetailsTranslation('company', isSpanish)}</h1>
          <div className='flex justify-end items-center gap-2'>
            <button className=' flex gap-2 items-center' onClick={() => {
                dispatch(setShowBackToDashboardButton(true));
              navigate("/user-management")
            }}>
              <p>{getReviewUserDetailsTranslation('update', isSpanish)}</p>
              <ArrowUpRight className='w-6 h-6' />
            </button>
          </div>
        </div>
        <div className='p-4 border-container rounded-xl form'>
          <div className='flex gap-4'>
            <div className="form-group flex-1" id='nombre'>
              <label htmlFor="nombre">{getReviewUserDetailsTranslation('companyName', isSpanish)}</label>
              <p className='font-bold'>{company.nombre}</p>
            </div>
            <div className="form-group flex-1" id='correo_electronico'>
              <label htmlFor="correo_electronico">{getReviewUserDetailsTranslation('companyEmail', isSpanish)}</label>
              <p className=' font-bold'>{company.correo_electronico}</p>
            </div>
          </div>
          <div className='flex gap-4'>
            <div className="form-group flex-1" id='nif'>
              <label htmlFor="nif">{getReviewUserDetailsTranslation('nif', isSpanish)}</label>
              <p className='font-bold'>{company.nif}</p>
            </div>
            <div className="form-group flex-1" id='eori'>
              <label htmlFor="eori">{getReviewUserDetailsTranslation('eoriNumber', isSpanish)}</label>
              <p className=' font-bold'>{company.eori}</p>
            </div>
          </div>
          <div className="form-group" id='direccion'>
            <label htmlFor="direccion">{getReviewUserDetailsTranslation('address', isSpanish)}</label>
            <p className='font-bold'>{company.direccion}</p>
          </div>
          <div className='flex gap-4'>
            <div className="form-group flex-1" id='localidad'>
              <label htmlFor="localidad">{getReviewUserDetailsTranslation('city', isSpanish)}</label>
              <p className=' font-bold'>{company.localidad}</p>
            </div>
            <div className="form-group flex-1" id='codigo_postal'>
              <label htmlFor="codigo_postal">{getReviewUserDetailsTranslation('postalCode', isSpanish)}</label>
              <p className='font-bold'>{company.codigo_postal}</p>
            </div>
          </div>
          <div className='flex gap-4'>
          <div className="form-group flex-1" id='pais'>
            <label htmlFor="pais">{getReviewUserDetailsTranslation('country', isSpanish)}</label>
            <p className='font-bold'>{company.pais}</p>
          </div>
          <div className="form-group flex-1" id='aduana_habitual'>
            <label htmlFor="aduana_habitual">{getReviewUserDetailsTranslation('standardCustomsOffice', isSpanish)}</label>
            <p className='font-bold'>{company.aduana_habitual}</p>
          </div>
          </div>
        </div>
      </div>
    )
  }